// @ts-nocheck
const asBool = value => value === 'true';

export const config = {
    login: {
        clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
        redirectUri: `${window.location.origin}/redirect`,
    },
    serviceEnvironment: import.meta.env.MODE,
    enableAppStart: asBool(import.meta.env.VITE_NO_TEST_RUN),
};
